import { IEvent } from "@Interfaces";
import { chainShortCircuits, EVENT_TYPE, getIsSingleSlot } from "@Utils";

const scrollToScheduleSelector = ({
    scheduleSelectorRef,
}: {
    scheduleSelectorRef: React.RefObject<HTMLDivElement>;
}): void => {
    /**
         * TODO @mayank: delete if not used by 1st July 2023
        if (scheduleSelectorRef?.current) {
            scheduleSelectorRef?.current?.scrollIntoView({
                behavior: "smooth",
            });
        } else {
            mainScrolledComponentRef?.current?.children?.[0]?.scroll({
                behavior: "smooth",
                top: 0,
            });
        }
         */
    scheduleSelectorRef?.current?.scrollIntoView({
        behavior: "smooth",
    });
};

export const handleDisabledCtaClick = ({
    disablePayment,
    event,
    eventData,
    scheduleSelectorRef,
    needUserInputToProceed,
    messageForUserToProceed,
}: {
    disablePayment?: boolean;
    event: IEvent.IStore;
    eventData: IEvent.IEventData;
    scheduleSelectorRef: React.RefObject<HTMLDivElement>;
    needUserInputToProceed: boolean;
    messageForUserToProceed?: string;
}) => {
    const eventType = eventData.type;
    const {
        paymentInfo: { slots, quantity },
    }: IEvent.IStore = event;

    const isSingleSlot = getIsSingleSlot({ eventData });

    const isMerchandise = eventType === EVENT_TYPE.MERCHANDISE;
    const merchQuantityNotSelected =
        !disablePayment && isMerchandise && !quantity;
    const slotNotSelected =
        !disablePayment && !isSingleSlot && !isMerchandise && slots.length < 1;

    const {
        variantsData,
        selectedVariant,
        shipping_details: shippingDetails,
        enable_shiprocket: shiprocketEnabled,
    } = eventData;

    const disabledClickAlertText = chainShortCircuits(
        [
            [needUserInputToProceed, messageForUserToProceed],
            [merchQuantityNotSelected, "Please select a quantity"],
            [
                // This case above should not occur as quantity is limited
                // to min:1, however, added for possible future error handling
                slotNotSelected,
                "Please select a slot before proceeding",
            ],
            [
                isMerchandise && variantsData?.variants && !selectedVariant,
                "Please select variant type",
            ],
            [
                // pincode is mandatory in case of shiprocket
                isMerchandise && shiprocketEnabled && !shippingDetails?.pincode,
                "Please enter delivery pincode.",
            ],
        ],
        null
    );
    if (disabledClickAlertText) alert(disabledClickAlertText);
    if (merchQuantityNotSelected || slotNotSelected) {
        scrollToScheduleSelector({ scheduleSelectorRef });
    }
};
